'use client';

import React, { useCallback } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import Link from 'components/consumer/Link';
import classNames from 'classnames';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from 'components/consumer/consumer-search/commons/helpers';

/**
 * SeeAllButton - Next/v7 version
 */
const SeeAllButtonNext = ({ toggleSearchOpen, variant = 'desktop' }) => {
  const { results } = useInstantSearch();
  const currentPage = useUserCurrentPageType();

  const handleClick = useCallback(async () => {
    await toggleSearchOpen?.();
    avo.productsSearched({
      query: results?.query ?? '',
      location: currentPage,
      searchTarget: avo.SearchTarget.FULL_RESULTS,
    });
  }, [toggleSearchOpen, results?.query, currentPage]);

  if (!results?.query) {
    return null;
  }

  return (
    <Link
      onClick={handleClick}
      to={getAdvancedSearchUrlForQueryAndIndex(results.query, 'products')}
    >
      <div
        className={classNames(
          'p-2.5 border-solid border-gray cursor-pointer font-bold tracking-[-.0125rem] leading-[1.45rem] text-base bg-gray',
          {
            'text-center w-[200px] h-[50px] border-2 text-white':
              variant === 'desktop',
            'text-left w-auto h-auto pt-0 pr-0 pb-0 pl-2.5 border-0 bg-transparent text-gray mr-5':
              variant === 'mobile',
          }
        )}
      >
        See full results ({results.nbHits})
      </div>
    </Link>
  );
};

export default SeeAllButtonNext;
